import React, {useEffect, useState} from 'react';
import { makeStyles, createMuiTheme } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

import { IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl';
import { sansSerfifFamily } from '../layout/layout.styles';

const theme = createMuiTheme({
  shadows: ['none'],
  overrides: {
    MuiPaper: {
      root: {
        top: '50px !important',
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: '#F2F3F6',
        },

        backgroundColor: '#F2F3F6',
      },
    },
  },
  typography: {
    fontFamily: sansSerfifFamily,
    fontWeightBold: 700,
    fontSize: 16,
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',

    top: 56,
    right: 100,
    fontWeight: 'bold',
    zIndex: 5,
  },
  formControl: {
    backgroundColor: '#F2F3F6',
    position: 'fixed',
    color: '#456673',
    padding: '3px 8px 0px 8px',
    fontWeight: 'bold',
    borderRadius: '4px',
    '&:focus': {
      backgroundColor: '#F2F3F6',
    },
    '&:hover': {
      backgroundColor: '#F2F3F6',
    },

    '&:after': {
      borderBottomColor: '#456673',
    },
    '& .MuiSvgIcon-root': {
      color: '#456673',
      paddingRight: '1px',
    },

    '& .MuiSelect-select.MuiSelect-select': {
      paddingRight: '20px',
    },
  },

  itemStyle: {
    color: '#456673',
    fontWeight: 'bold',
  },
}));

const languageName = {
  en: 'EN',
  es: 'ES',
  fr: 'FR',
};

export const Language = () => {
  const classes = useStyles(); 
  const [Isloaded, setIsloaded] = useState(false);
  useEffect(() => {
    setIsloaded(true);
  }, []);
  return Isloaded ? (
    <ThemeProvider theme={theme}>
      <IntlContextConsumer>
        {({ languages, language: currentLocale }) => (
          <div className={classes.root}>
            <Select
              variant="standard"
              size="small"
              labelId="label"
              id="demo-simple-select-filled"
              className={classes.formControl}
              MenuProps={{
                MenuListProps: {
                  disablePadding: true,
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'center',
                },
                getContentAnchorEl: null,
              }}
              disableUnderline={true}
              value={currentLocale}
              onChange={(val) => {
                changeLocale(val.target.value);
              }}
            >
              {languages.map((language) => (
                <MenuItem className={classes.itemStyle} key={language} value={language}>
                  {languageName[language]}
                </MenuItem>
              ))}
            </Select>
          </div>

        )}
      </IntlContextConsumer>
    </ThemeProvider>
  ): null
};
